import React from "react";
import { getInitials } from "@/utils/format";

interface AvatarProps {
    name?: string | null;
    src?: string | null;
    size?: "sm" | "md" | "lg";
    className?: string;
}

const sizes = {
    sm: "h-6 w-6 text-[10px]",
    md: "h-8 w-8 text-xs",
    lg: "h-10 w-10 text-sm",
};

export const Avatar: React.FC<AvatarProps> = ({ name, src, size = "md", className = "" }) => (
    <div className={`inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-slate-200 text-slate-700 uppercase dark:bg-zinc-700 dark:text-zinc-200 ${sizes[size]} ${className}`}>
        {src ? <img src={src} alt="" className="h-full w-full object-cover" /> : getInitials(name)}
    </div>
);
